import { GET_BIND_PAGE } from './bind-page.query';
import { GET_POLICY_PAGE } from './policy-page.query';
import { GET_QUOTES } from './quotes.query';
import { GET_RATER } from './rater.query';
import { GET_SUBMISSION } from './submission.query';
import { graphql } from '../gql';
import { useMutation } from '@apollo/client';

export const UPSERT_QUOTE = graphql(`
  mutation upsertQuote(
    $submissionUuid: String!
    $details: QuoteInput!
    $coverages: [HasCoverageInput!]!
    $endorsements: [HasEndorsementInput!]!
    $subjectivities: [HasSubjectivityInput!]!
    $scheduleRatings: [HasScheduleRatingInput!]!
    $enterpriseRatings: [HasEnterpriseRatingInput!]!
    $excessTowerLayers: [ExcessTowerLayerInput!]!
  ) {
    upsertQuote(
      submissionUuid: $submissionUuid
      details: $details
      coverages: $coverages
      endorsements: $endorsements
      subjectivities: $subjectivities
      scheduleRatings: $scheduleRatings
      enterpriseRatings: $enterpriseRatings
      excessTowerLayers: $excessTowerLayers
    ) {
      uuid
    }
  }
`);

export function useUpsertQuoteMutation() {
  const [upsertQuote, { loading, error, reset }] = useMutation(UPSERT_QUOTE, {
    refetchQueries: [GET_QUOTES, GET_RATER, GET_SUBMISSION],
    awaitRefetchQueries: true,
  });

  return {
    upsertQuote,
    loading,
    error,
    reset,
  };
}

export function useUpsertQuoteSubjectivityMutation() {
  const [upsertQuote, { loading, error, reset }] = useMutation(UPSERT_QUOTE, {
    refetchQueries: [GET_BIND_PAGE, GET_POLICY_PAGE],
    awaitRefetchQueries: true,
  });

  return {
    upsertQuote,
    loading,
    error,
    reset,
  };
}
